import React, { MutableRefObject, useRef } from "react";
import Style from "./index.module.scss";
import { Button, Icon, Input, message, Tooltip } from "antd";
import { useToggle } from "react-use";
import DeleteConfirm from "../../../../../../components/DeleteConfirm";
import { ChapterTree } from "../../../../../../service/CourseDetail/chapter";
import lodash from "lodash-es";

interface Prop {
    onMove: () => void;
    onAppend: (id: number) => void;
    onDelete: (item: ChapterTree) => void;
    onEdit: (id: number, parentId: number, chapterName: string) => void;
    data: ChapterTree;
}
const Index = ({ onMove, data, onAppend, onDelete, onEdit }: Prop) => {
    const InputEl: MutableRefObject<any> = useRef(null);
    const [edit, toggleEdit] = useToggle(false);

    function deleteEvent() {
        onDelete(data);
    }
    function appendEvent(e: any) {
        onAppend(data.id);
        e.stopPropagation();
    }
    function submit(e: any) {
        const value = InputEl.current.state.value;
        if (lodash.trim(value).length < 1) {
            return message.warn("请输入名称");
        }
        onEdit(data.id, data.parentId, InputEl.current.state.value);
        toggleEdit();
        e.stopPropagation();
    }
    function moveEvent() {
        onMove();
    }

    function Write() {
        return (
            <div className={Style.write}>
                <Input
                    ref={InputEl}
                    size={"small"}
                    maxLength={200}
                    defaultValue={data?.chapterName}
                />
                <Tooltip placement="top" title="保存">
                    <Icon type="check" onClick={submit} />
                </Tooltip>
                <Tooltip placement="top" title="取消">
                    <Icon type="close" onClick={toggleEdit} />
                </Tooltip>
            </div>
        );
    }

    return (
        <div className={Style.root}>
            <dl>
                <dt>
                    {edit ? (
                        <Write />
                    ) : data?.chapterName?.length > 15 ? (
                        <Tooltip placement="top" title={data?.chapterName}>
                            <b>{data?.chapterName}</b>
                        </Tooltip>
                    ) : (
                        <b>{data?.chapterName}</b>
                    )}
                    {data.id !== 0 && !edit && (
                        <div onClick={toggleEdit}>
                            <Tooltip placement="top" title="编辑">
                                <Icon type="edit" />
                            </Tooltip>
                        </div>
                    )}
                </dt>
                <dd>
                    {data.level !== 3 && (
                        <div>
                            <Button
                                onClick={appendEvent}
                                type="link"
                                size="small">
                                添加子级
                            </Button>
                        </div>
                    )}
                    {data.id !== 0 && (
                        <div>
                            <Button
                                onClick={moveEvent}
                                type="link"
                                size="small">
                                移动
                            </Button>
                        </div>
                    )}
                    {data.id !== 0 && (
                        <div>
                            <DeleteConfirm
                                title="确认删除章节节点吗？"
                                content="删除当前所选章节节点后，该章节下的课件也将被一并删除"
                                onSuccess={deleteEvent}>
                                <Button type="link" size="small">
                                    删除
                                </Button>
                            </DeleteConfirm>
                        </div>
                    )}
                </dd>
            </dl>
        </div>
    );
};

export default Index;
